import { render } from "./DeleteInfoModal.vue?vue&type=template&id=5985d072&scoped=true"
import script from "./DeleteInfoModal.vue?vue&type=script&lang=js"
export * from "./DeleteInfoModal.vue?vue&type=script&lang=js"

import "./DeleteInfoModal.vue?vue&type=style&index=0&id=5985d072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5985d072"]])

export default __exports__